import styled from 'styled-components';
import { ContentWrapperStyled } from '../pageWrapper';

export const FooterContainerStyled = styled.div`
  background-color: ${({ theme }): string => theme.COLOR.BLACK};
  color: ${({ theme }): string => theme.COLOR.WHITE};
`;

export const FooterContentStyled = styled(ContentWrapperStyled)``;
